import clsx from "clsx";
import type { JSX } from "react";

import { LoadingSkeleton } from "../LoadingSkeleton";

interface ProductFieldProps {
  label: string;
  value?: string;
  customValue?: React.ReactNode;
  boldStyle?: boolean;
  loading?: boolean;
}

export const ProductField = ({ label, value, customValue, boldStyle, loading }: ProductFieldProps): JSX.Element => (
  <div>
    <p className="mb-1 font-bold">{label}</p>

    {loading ? (
      <LoadingSkeleton kind="paragraph" />
    ) : (
      customValue || <p className={clsx({ "font-bold text-brand-primary": boldStyle })}>{value}</p>
    )}
  </div>
);
